import styled from 'styled-components';
import { Link } from '~/components/link';

export const VnmTermsLink = styled(Link)`
  white-space: nowrap;
  display: inline-block;
`;

export const RewardsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
